interface Options {
  blockUntilMounted?: boolean
}

const useScrollBlock = (options: Options) => {
  const blockScroll = (block = true) => {
    useHead({
      bodyAttrs: {
        style: block
          ? `overflow: hidden; height: 100vh;`
          : 'overflow: visible; height: auto;',
      },
    })
  }

  options.blockUntilMounted ? blockScroll() : undefined

  onMounted(() => {
    if (options.blockUntilMounted) {
      blockScroll(false)
    }
  })

  return { blockScroll }
}

export default useScrollBlock
